import { gql } from '@/__generated__/gql'

export const ContentProviderMetadataFragment = gql(`
  fragment Content_ProviderMetadataFragment on Content{
    providerMetadata: contentProvider{
      metadata
      ...Content_ProviderCommonFragment
    }
  }
`)
